import React, { useState, useEffect } from "react";
import { Col, Modal, Nav, Row, Tab, Image, Button } from "react-bootstrap";
import icNext from "../../../assets/images/ic-arrow-next.svg";
import "bootstrap/dist/css/bootstrap.min.css";

const EthicsCounsellorEdit =( { title , data }: { title?: string; data: any; }) => {  
  

  return (
    <>
        <a href="/ethicscounsellorDetails">
        <b>
          VIEW ALL
          <span style={{ fontSize: "18px" }}>
              <Image
              src={icNext}
              style={{
                width: "18px",
                height: "18px",
              }}/>
              </span>
        </b>
        </a>
        {/* <a href="/learningmodulesDetails"> <Image src={Dots} /> </a>          */}
    </>

  );
}


export default EthicsCounsellorEdit;
